export const programs = [
  {
    id: 1,
    label: '핵심',
    title: '입시반',
    subtitle: '예고 · 예대 입시 전문',
    description: '예술고등학교, 연극영화과, 방송연예과 등 입시를 목표로 하는 학생들을 위한 체계적인 입시 전문 과정입니다. 실기 준비부터 면접까지 완벽하게 대비합니다.',
    details: ['1:1 맞춤 실기 지도', '모의 오디션 정기 진행', '합격률 95% 이상'],
    image: 'https://public.readdy.ai/ai/img_res/fdbb464676e50f9ea6d23790437fb1db.jpg',
    curriculum: {
      target: '예고·예대 입시를 준비하는 중·고등학생',
      schedule: '연기 주3회 (월,수,금) / (화,목,토)',
      duration: '3개월 ~ 1년 과정',
      steps: [
        { step: '1단계', title: '기초 발성 & 신체 훈련', desc: '호흡법, 발성, 발음 교정, 신체 이완 및 표현력 기초' },
        { step: '2단계', title: '감정 연기 & 장면 분석', desc: '감정 이해, 상황 분석, 대본 읽기, 씬 스터디' },
        { step: '3단계', title: '실기 집중 & 모의 오디션', desc: '실기 곡/대사 완성, 모의 오디션 반복 훈련, 피드백' },
        { step: '4단계', title: '최종 실전 대비', desc: '면접 준비, 자기소개, 지원 학교별 맞춤 전략 수립' },
      ],
      curriculumImages: [
        'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/729f60b96517f8265d62ebb0f5f821a3.jpeg',
        'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/654017b7f1e9921a24e7e4e2440947c5.jpeg',
        'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/1c306020beb1992a6fec42b63f9defc2.jpeg',
      ],
    },
  },
  {
    id: 2,
    label: '인기',
    title: '취미반',
    subtitle: '입문 · 교양 과정',
    description: '연기에 관심 있는 누구나 부담 없이 시작할 수 있는 취미 과정입니다. 발성, 표현력, 즉흥 연기 등을 재미있게 배울 수 있습니다.',
    details: ['월,금 수업진행', '소그룹 맞춤수업', '개인역량강화'],
    image: 'https://readdy.ai/api/search-image?query=adults%20enjoying%20acting%20drama%20workshop%20cheerful%20expressive%20warm%20cozy%20interior%20wooden%20floor%20spacious%20bright%20room%20people%20stretching%20gesturing%20smiling%20natural%20light%20casual%20clothes%20relaxed%20happy%20atmosphere%20group%20class&width=500&height=600&seq=prog_hobby_2026a&orientation=portrait',
    curriculum: {
      target: '중학생 이상 누구나',
      schedule: '주 2회 (월·금)',
      duration: '월 단위 수강 가능',
      steps: [
        { step: '1단계', title: '기초 발성 & 표현 놀이', desc: '긴장 완화, 발성 기초, 표정·몸짓 표현 게임' },
        { step: '2단계', title: '즉흥 연기 & 상황극', desc: '즉흥 연기 훈련, 소그룹 상황극, 자유 표현 활동' },
        { step: '3단계', title: '단막극 준비 & 발표', desc: '짧은 작품 선정, 역할 배분, 소규모 발표회 진행' },
      ],
      curriculumImages: [
        'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/cd2784a1f0a9b85d51f7efb351981bc4.jpeg',
      ],
    },
  },
  {
    id: 3,
    label: '전문',
    title: '전문배우반',
    subtitle: '직업 배우 양성 과정',
    description: '프로 배우를 목표로 하는 분들을 위한 심화 과정입니다. 캐릭터 분석, 감정 연기, 카메라 연기, 영상 촬영 실습까지 현업 수준으로 훈련합니다.',
    details: ['프로필촬영 포트폴리오 제작', '오디션 촬영 및 지도', '개인캐릭터 분석'],
    image: 'https://readdy.ai/api/search-image?query=professional%20korean%20actor%20portrait%20solo%20cinematic%20film%20set%20moody%20dark%20background%20dramatic%20side%20lighting%20confident%20serious%20expression%20film%20industry%20camera%20crew%20professional%20acting%20training%20studio&width=500&height=600&seq=prog_pro_2026a&orientation=portrait',
    curriculum: {
      target: '프로 배우를 목표로 하는 성인',
      schedule: '주 3회 협의 후 결정',
      duration: '6개월 ~ 1년 과정',
      steps: [
        { step: '1단계', title: '개인 캐릭터 분석', desc: '자기 분석, 개인 특성 파악, 캐릭터 유형 연구' },
        { step: '2단계', title: '카메라 연기 & 영상 실습', desc: '카메라 앞 연기, 앵글 이해, 영상 촬영 실습' },
        { step: '3단계', title: '오디션 대비 & 촬영 지도', desc: '오디션 영상 제작, 실전 오디션 트레이닝' },
        { step: '4단계', title: '포트폴리오 완성', desc: '프로필 사진 촬영, 포트폴리오 제작, 배우 이력서 완성' },
      ],
      curriculumImages: [],
    },
  },
  {
    id: 4,
    label: '뮤지컬',
    title: '뮤지컬반',
    subtitle: '노래 · 연기 · 댄스 통합 과정',
    description: '뮤지컬 배우를 꿈꾸는 분들을 위한 통합 퍼포먼스 과정입니다. 발성과 노래, 무대 연기, 안무까지 뮤지컬에 필요한 모든 요소를 체계적으로 훈련합니다.',
    details: ['보컬 · 연기 · 댄스 3in1 훈련', '정기 뮤지컬 쇼케이스 공연', '입시 · 오디션 대비 지도'],
    image: 'https://readdy.ai/api/search-image?query=musical%20theater%20students%20performing%20on%20stage%20vibrant%20colorful%20spotlight%20dramatic%20costumes%20singing%20dancing%20chorus%20line%20elegant%20theater%20interior%20dark%20background%20energetic%20ensemble%20cast%20emotional%20powerful%20scene%20broadway%20style&width=500&height=600&seq=prog_musical_2026a&orientation=portrait',
    curriculum: {
      target: '뮤지컬 배우를 목표로 하는 청소년 및 성인',
      schedule: '주 2회 4타임 (화·목)',
      duration: '3개월 ~ 1년 과정',
      steps: [
        { step: '1단계', title: '발성 & 기초 보컬', desc: '복식호흡, 발성 교정, 음정·박자 훈련, 뮤지컬 곡 기초 해석' },
        { step: '2단계', title: '무대 연기 & 안무', desc: '뮤지컬 씬 연기, 기초 재즈 댄스, 스테이지 무브먼트 훈련' },
        { step: '3단계', title: '앙상블 & 쇼케이스 준비', desc: '앙상블 합창, 듀엣·군무 연습, 장면 통합 연기' },
        { step: '4단계', title: '쇼케이스 공연 & 오디션 대비', desc: '정기 쇼케이스 공연 무대, 입시·오디션 실전 트레이닝' },
      ],
      curriculumImages: [],
    },
  },
  {
    id: 5,
    label: '무용',
    title: '현대무용반',
    subtitle: '신체 표현 · 예술 무용 과정',
    description: '신체를 통한 예술적 표현을 탐구하는 현대무용 전문 과정입니다. 기초 테크닉부터 즉흥 표현, 안무 창작까지 창의적인 신체 언어를 개발합니다.',
    details: ['기초 테크닉 & 신체 훈련', '즉흥 표현 & 안무 창작', '정기 발표회 참가'],
    image: 'https://readdy.ai/api/search-image?query=contemporary%20modern%20dance%20student%20in%20black%20outfit%20fluid%20graceful%20movement%20dance%20studio%20wooden%20floor%20expressive%20body%20gesture%20artistic%20abstract%20performance%20minimalist%20aesthetic%20dramatic%20lighting%20solo%20dancer%20elegant%20pose&width=500&height=600&seq=prog_dance_2026a&orientation=portrait',
    curriculum: {
      target: '현대무용에 관심 있는 청소년 및 성인 누구나',
      schedule: '주 2회 3타임',
      duration: '3개월 ~ 1년 과정',
      steps: [
        { step: '1단계', title: '신체 인식 & 기초 테크닉', desc: '스트레칭, 유연성 훈련, 무게중심 이동, 플로어 워크 기초' },
        { step: '2단계', title: '현대무용 테크닉 심화', desc: '릴리즈 테크닉, 콘택트 즉흥, 공간 활용 움직임 훈련' },
        { step: '3단계', title: '즉흥 표현 & 안무 창작', desc: '음악 즉흥 반응, 개인 움직임 어휘 개발, 소품 활용 창작' },
        { step: '4단계', title: '작품 완성 & 정기 발표회', desc: '개인·그룹 작품 완성, 정기 발표회 무대 공연 경험' },
      ],
      curriculumImages: [],
    },
  },
];
